module.exports = __webpack_public_path__ + "img/4.383936ce.png";